import { render } from "./FoliosEnrollment.vue?vue&type=template&id=24ca32a2&ts=true"
import script from "./FoliosEnrollment.vue?vue&type=script&lang=ts"
export * from "./FoliosEnrollment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__